var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('VendorController', [
    '$scope',
    '$window',
    'elasticService',
    "$location",
    "$anchorScroll",
    function (
        $scope,
        $window,
        elasticService,
        location,
        $anchorScroll

    ) {

        //#region Initialization
        $scope.brands = {
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 1,
            elasticBrands: [],
            displayedBrands: []
        };

        $scope.currentSection = 'newVendorAbout';
        //#endregion

        //#region Screen Resize
        $scope.windowWidth = $window.innerWidth;
        angular.element($window).bind('resize', function () {
            $scope.windowWidth = $window.innerWidth;
            $scope.paginateBrands(1);
            $scope.$apply();
        });
        //#endregion

        //#region Paginate Brands
        $scope.paginateBrands = function (currentPage) {
            if ($scope.windowWidth >= 1200) {
                $scope.brands.itemsPerPage = 4;
            }
            else if ($scope.windowWidth > 720 && $scope.windowWidth < 1200) {
                $scope.brands.itemsPerPage = 3;
            }
            else if ($scope.windowWidth >= 571 && $scope.windowWidth <= 720) {
                $scope.brands.itemsPerPage = 2;
            }
            else {
                $scope.brands.itemsPerPage = 1;
            }
            $scope.brands.currentPage = currentPage;
            $scope.brands.totalPages = Math.ceil($scope.brands.elasticBrands.length / $scope.brands.itemsPerPage);
            $scope.brands.displayedBrands = $scope.brands.elasticBrands.slice(($scope.brands.currentPage - 1) * $scope.brands.itemsPerPage, $scope.brands.currentPage * $scope.brands.itemsPerPage);
        }
        //#endregion

        //#region Get Brands
        getBrands = function () {
            elasticService.getElasticData(elasticService.buildBrands('StockDesign')).then(function (response) {
                if (
                    response &&
                    response.data &&
                    response.data.aggregations &&
                    response.data.aggregations.brands &&
                    response.data.aggregations.brands.buckets &&
                    response.data.aggregations.brands.buckets.length > 0
                ) {
                    response.data.aggregations.brands.buckets.forEach(function (brand) {
                        $scope.brands.elasticBrands.push({
                            name: brand.key,
                            imgUrl:
                                "/common/images/brandicons/" +
                                brand.key.toLowerCase().replace(/ /g, "-") +
                                ".png",
                            brandUrl: "/stockdesign/brands/" +
                                brand.key.toLowerCase().replace(/ /g, "-"),
                        });
                        $scope.paginateBrands(1);
                    });
                }
            });
        };

        getBrands();
        //#endregion
        var duration = 1000;
        //#region Menu
        $scope.scrollToSection = function (id, invertdrpdwn) {
            if (invertdrpdwn) {
                $scope.drpdownExpanded = !$scope.drpdownExpanded;
            }
            $scope.currentSection = id;
            $scope.scrollToElement(id);
        }

        $scope.scrollToElement = function (id) {
            var elem = document.getElementById(id);
            if (elem != null) {
                elem.scrollIntoView({ behavior: "smooth" });
            }
        };


        //#endregion

    }]);
